import { Navigate, Outlet } from "react-router-dom";

const PublicRoutesOutlet = () => {
  const auth = { token: localStorage.getItem('access_token_PA_Admin') };
  // const auth = { token: "Authenticated" };
  return !auth.token ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      {/* <header className="App-header">
        <Login />
      </header> */}
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PublicRoutesOutlet;
